var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 0.875L4.15625 9.625L1.0625 6.53125C0.90625 6.40625 0.6875 6.40625 0.53125 6.53125L0.1875 6.90625C0.03125 7.03125 0.03125 7.28125 0.1875 7.4375L3.90625 11.1562C4.03125 11.2812 4.28125 11.2812 4.40625 11.1562L13.7812 1.78125C13.9375 1.625 13.9375 1.375 13.7812 1.25L13.4375 0.875C13.2812 0.75 13.0625 0.75 12.9062 0.875Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f2fca912.svg";
export { ForwardRef as ReactComponent };